module.exports = __webpack_public_path__ + "img/logo2.3c0cd282.png";